import { Box, styled } from '@material-ui/core';

export const XContainer = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end'
});
